<template>
    <div class="flex h-100vh">
        <!-- 桌面端侧边栏 -->
        <div class="hidden md:block"><MenuSide /></div>

        <!-- 移动端菜单抽屉 -->
        <el-drawer
            v-model="mobileMenuVisible"
            direction="ltr"
            size="268px"
            :with-header="false"
            class="mobile-menu-drawer"
        >
            <MenuSide @menu-click="mobileMenuVisible = false" />
        </el-drawer>

        <div class="flex flex-1 flex-col min-w-0">
            <HeaderBar @toggle-menu="mobileMenuVisible = !mobileMenuVisible" />
            <div id="globalLoadingEl" class="bg-[var(--el-bg-color-page)] flex-1 min-w-0 overflow-auto p-3 md:p-5">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import HeaderBar from './components/HeaderBar.vue';
import MenuSide from './components/MenuSide.vue';
import { useMessageStore } from '@/stores/message';
import { useWfStore } from '@/stores/wf';

const mobileMenuVisible = ref(false);

// 消息中心：长连接（xqyy_msg）+ 未读汇总在后台入口统一启动
const messageStore = useMessageStore();

// 审批中心：待我审批角标（复用同一长连接的投递帧做刷新，不新建第二条 WS）
const wfStore = useWfStore();

onMounted(() => {
    // 消息中心：拉取未读并建立统一长连接（VITE_IM_BASE_URL 为空时不建连，仅 HTTP 拉取）
    messageStore.start();
    // 审批中心：拉取待办数并订阅同一长连接帧
    wfStore.start();
    // 登录后空闲时预加载所有 admin 页面组件，消除首次点击菜单的懒加载白屏
    const prefetch = () => {
        const modules = import.meta.glob('@/views/admin/**/*.vue');
        Object.entries(modules).forEach(([path, importer]) => {
            // 排除抽屉、弹窗等非页面组件
            if (path.includes('/components/')) return;
            importer(); // 触发加载，不 await，不阻塞
        });
    };

    if ('requestIdleCallback' in window) {
        requestIdleCallback(prefetch, { timeout: 3000 });
    } else {
        setTimeout(prefetch, 1000);
    }
});
</script>

<style lang="scss">
.mobile-menu-drawer {
    .el-drawer__body {
        padding: 0;
    }
}
</style>
